<template>
    <div id="ADCPGraph" style="background-color: #22293d;"></div>
</template>

<script>
    import Highcharts from 'highcharts';
    import loadVector from 'highcharts/modules/vector';
    import loadColor from 'highcharts/modules/coloraxis';
    import loadBoost from 'highcharts/modules/boost';

    export default {
        name: "ADCP-forecast",
        data: () => ({
            chart: null,
            textColor: "#fff",
            bgColor: "#22293d",
            isDarkMode: true,
            ADCPData: null
        }),
        watch: {
            '$route.query.style': function() {
                var globv = this;
                globv.checkStyle();
            },
        },
        mounted() {
            var globv = this;
            globv.checkStyle();
        },
        methods: {
            checkStyle: function() {
                var globv = this;
                if (globv.$route.query.style && globv.$route.query.style == "light") {
                    globv.textColor = "#22293d";
                    globv.bgColor = "#F5F9FA";
                    globv.isDarkMode = false;
                }
                else {
                    globv.textColor = "#fff";
                    globv.bgColor = "#22293d";
                    globv.isDarkMode = true;
                }

                if (globv.ADCPData && !globv.isDarkMode) {
                    globv.createChart(globv.ADCPData);
                }
            },
            createChart: function(ADCPInfo) {
                var globv = this;
                let ADCPData = ADCPInfo['data'];

                if (ADCPData) {
                    globv.ADCPData = ADCPData;
                    let data = [];

                    let title = "ADCP of ";
                    if (ADCPInfo['station']) {
                        title += ADCPInfo['station']
                    }
                    else {
                        title += globv.$route.params.station;
                    }

                    for (let a in ADCPData) {
                        data.push([ADCPData[a]['time'], ADCPData[a]['depth'], ADCPData[a]['speed'], ADCPData[a]['direction'] + 180]);
                    }

                    let colors = [
                        "#800080",
                        "#2362BA",
                        "#6DDF76",
                        "#FFE033",
                        "#F79C6A",
                        "#ED4553"
                    ]
                    let interval = 1 / (colors.length - 1);
                    let stops = colors.map((val, i) => [i * interval, val]);

                    loadColor(Highcharts);
                    loadVector(Highcharts);
                    loadBoost(Highcharts);

                    globv.chart = Highcharts.chart('ADCPGraph', {
                        chart: {
                            type: 'vector',
                            backgroundColor: globv.bgColor
                        },
                        credits: {
                            enabled: false,
                            credits: false
                        },
                        title: {
                            text: title,
                            style: {
                                color: globv.textColor
                            }
                        },
                        legend: {
                            layout: 'vertical',
                            align: 'right',
                            verticalAlign: 'top',
                            padding: 20,
                            itemStyle: {
                                color: globv.textColor
                            },
                        },
                        plotOptions: {
                            vector: {
                                vectorLength: 80,
                                turboThreshold: 0
                            }
                        },
                        yAxis: {
                            title: {
                                text: "Depth",
                                style: {
                                    color: globv.textColor
                                }
                            },
                            labels: {
                                enabled: true,
                                style: {
                                    color: globv.textColor
                                },
                                format: "{value} m"
                            },
                            reversed: true,
                            gridLineColor: "#666666",
                            max: 1000
                        },
                        xAxis: {
                            type: 'datetime',
                            crosshair: true,
                            labels: {
                                style: {
                                    color: globv.textColor
                                }
                            }
                        },
                        colorAxis: {
                            showInLegend: true,
                            labels: {
                                format: "{value} cm/s",
                                style: {
                                    color: globv.textColor
                                }
                            },
                            stops: stops
                        },
                        series: [{
                            name: "Ocean Current",
                            data: data,
                            showInLegend: false,
                            colorKey: 'length',
                            tooltip: {
                                pointFormatter: function() {
                                    let output = Highcharts.dateFormat('%A, %b %d, %H:%M', this.x) + '<br/>';
                                    output += "Depth: <b>" + this.y + " m</b><br/>";
                                    if (this.length != null) {
                                        output += "Speed: <b>" + (this.length).toFixed(3) + " cm/s</b><br/>";
                                        output += "Direction: <b>" + (this.direction - 180).toFixed(3) + "°</b>";
                                    }
                                    return output;
                                }
                            }
                        }],
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 820
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom',
                                        padding: 8,
                                    },
                                    colorAxis: {
                                        labels: {
                                            format: "{value}"
                                        }
                                    }
                                }
                            }]
                        }
                    });
                }

            },
            reflow: function() {
                var globv = this;
                if (globv.chart) {
                    globv.chart.reflow();
                }
            },
        }
    }
</script>
